module.exports = __webpack_public_path__ + "img/logo-mister-doner.a5edb38e.png";